// extracted by mini-css-extract-plugin
export default {"wrapper":"Blockchain_wrapper__oahzo","viewed":"Blockchain_viewed__IhB9+"};